const e = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M39.9%2013.8999V36.8999H0V13.8999H9.7L9.5%2030.7999H30.2L30.4%2013.8999H39.9Z'%20fill='%23212471'/%3e%3cpath%20d='M40%203.2001L39.8%209.1001H25.5L25.7%2026.0001H14.4L14.7%209.2001H0V3.1001L40%203.2001Z'%20fill='%23D2561D'/%3e%3c/svg%3e";
export {
  e as default
};
